/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import "./MenuSummaryAlignPicker.css";

/**
 * Toggle “+” between category rows on the customer menu summary (per menu).
 */
export default function MenuSummaryPlusPicker({ value, onChange, idPrefix = "menu-summary-plus" }) {
  const { t } = useTranslation();
  const id = `${idPrefix}-show-plus-between-categories`;
  return (
    <div className="menu-summary-align-picker">
      <h3 className="menu-summary-align-picker__title">
        {t("menuSummaryPlusBetweenCategoriesLabel")}
      </h3>
      <p className="menu-summary-align-picker__hint">
        {t("menuSummaryPlusBetweenCategoriesHint")}
      </p>
      <div className="form-check form-switch m-0">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          id={id}
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          aria-label={t("menuSummaryPlusBetweenCategoriesLabel")}
        />
        <label className="form-check-label ms-2" htmlFor={id}>
          {t("menuSummaryPlusBetweenCategoriesSwitch")}
        </label>
      </div>
    </div>
  );
}
